var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrow = function SvgArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "iconfinder_Download_1031520")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ALL-Simbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atom/icon/arrow/default",
    transform: "translate(-5.000000, -3.000000)",
    fill: "#353531",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_Download_1031520",
    transform: "translate(11.000000, 11.000000) rotate(-180.000000) translate(-11.000000, -11.000000) translate(5.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.27,15.707 C5.659,16.092 6.31,16.096 6.699,15.707 L11.5,11 C11.895,10.609 11.894,9.976 11.5,9.586 C11.106,9.195 10.466,9.195 10.072,9.586 L6.995,12.593 L7,1 C7,0.448 6.548,0 5.99,0 C5.432,0 4.98,0.448 4.98,1 L4.975,12.593 L1.928,9.586 C1.533,9.195 0.894,9.195 0.5,9.586 C0.105,9.977 0.105,10.61 0.5,11 L5.27,15.707 Z",
    id: "Path"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow.9425afbb.svg";
export { ForwardRef as ReactComponent };